import { MarketingPoint, MarketingStep, PracticalItem } from './types'

const POINTS: MarketingPoint[] = [
  {
    title: 'You can see them reading it.',
    body: "Every recipient gets their own private link, so an open is tied to a name. You'll know the owner opened it twice before lunch, and you'll know who's gone quiet.",
  },
  {
    title: 'The back-and-forth stays on the quote.',
    body: "Questions and change requests land right under the line items, not buried in a reply-all. Revise, resend, and it's the same link with the whole history attached.",
  },
  {
    title: 'The yes is on the record.',
    body: "One tap to approve, saved with the name and the time. Six weeks later there's nothing to argue about. It's signed, and you can show exactly when.",
  },
]

const PRACTICAL: PracticalItem[] = [
  {
    title: 'Your brand on it',
    body: 'Your logo and colours, on the page and the PDF.',
  },
  {
    title: 'Payment stays yours',
    body: 'Drop in your own link. We never touch the money or add a card fee.',
  },
  {
    title: 'A PDF of every version',
    body: 'Each send is frozen and filed. Nothing gets lost.',
  },
  {
    title: 'Links that expire',
    body: 'Seven days, then the link goes dead. No stale quotes drifting around.',
  },
]

const STEPS: MarketingStep[] = [
  {
    number: '01',
    title: 'Build it',
    body: 'Line items, discount, tax. The total keeps up as you type.',
  },
  {
    number: '02',
    title: 'Send it',
    body: 'Each person gets a private link by email or text.',
  },
  {
    number: '03',
    title: 'They sign off',
    body: 'They read, they ask, they approve. You get pinged the second they do.',
  },
]

export { POINTS, PRACTICAL, STEPS }
